import React from "react";
import { bool } from "prop-types";
import { Box, CircularProgress } from "@mui/material";

const ProgressIndicator = ({ active }) => {
  if (active) {
    return (
      <Box
        sx={{
          padding: 8,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: `calc(100% - 128px)`,
        }}
      >
        <CircularProgress aria-label="Loading" />
      </Box>
    );
  }
  return null;
};

ProgressIndicator.propTypes = {
  active: bool.isRequired,
};

export default ProgressIndicator;
